import { MainAppState } from "../../../main/types";

import { PartnerJson } from "../types/partner";

export type GetPartners = (state: MainAppState) => PartnerJson[];

export const getPartners: GetPartners = (state) => state.consumerApi.partners;
